const MEASUREMENT_ID = process.env.GATSBY_GA_MEASUREMENT_ID

function gtag(...args) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return
  window.gtag(...args)
}

// The analytics transport injected into @evertech/funeral-ui's <FuneralUIProvider>
// (analytics={{ track: trackEvent }}). The package owns the site_* and memorial_*
// event taxonomies (src/analytics/{siteEvents,events}.js) and calls this transport,
// which keeps all window.gtag access in one place. No-op until
// GATSBY_GA_MEASUREMENT_ID is set, so dev builds are safe without it.
export function trackEvent(eventName, params = {}) {
  if (!MEASUREMENT_ID) return
  gtag("event", eventName, params)
}

// The SPA page_view, called from gatsby-browser.js `onRouteUpdate`. gatsby-ssr.js
// configures gtag with `send_page_view: false`, so this is the ONLY page_view the
// site sends — for the cold load as well as every in-app navigation.
//
// DEFERRED BY TWO ANIMATION FRAMES ON PURPOSE. `onRouteUpdate` runs before
// Gatsby's Head API (and react-helmet, which titles the obituaries page) commits
// the new <title>, so reading document.title synchronously sent `page_title: ""`
// on every cold load and the PREVIOUS page's title on every in-app navigation —
// silently mislabelling the whole report. Verified in-browser, not assumed. This
// is the same deferral gatsby-plugin-google-gtag uses.
//
// Because the send is deferred, `page_location` is passed explicitly rather than
// left to gtag's own document.location read. `page_path` is a Universal
// Analytics parameter that GA4 ignores; it is kept only because it predates this
// change and costs nothing, and `page_location` is what GA4 actually reports on.
//
// A TIMER, NOT requestAnimationFrame — deliberately diverging from
// gatsby-plugin-google-gtag, whose double-rAF has a bug we must not copy: a
// hidden tab never runs animation frames, so every visitor who middle-clicks or
// cmd-clicks a link into a background tab (or restores a session) would have
// their page_view silently dropped. Measured in-browser: with
// document.hidden === true the rAF callback never ran and the timer did.
// Dropping the pageview outright is strictly worse than the stale title this
// deferral exists to fix. React effects — including the one Gatsby's Head API
// commits the title in — do run in hidden tabs, so the timer gets a fresh title
// either way.
// A blank title is OMITTED rather than sent as "". Pages that title themselves
// through react-helmet (the memorial route) rather than a Gatsby `Head` export
// commit the title on an animation frame, so a hidden tab can still lose the
// race with this timer — and gtag falls back to reading document.title itself
// when the parameter is absent, whereas an explicit "" is recorded verbatim and
// shows up in GA4 as a real, empty page.
export function trackPageView(location) {
  if (!MEASUREMENT_ID || typeof window === "undefined") return
  setTimeout(() => {
    gtag("event", "page_view", {
      page_location: window.location.href,
      page_path: location.pathname + location.search,
      ...(document.title ? { page_title: document.title } : {}),
    })
  }, 32)
}
